import axios from "axios";
import { getCSRFToken } from "./django";

const api = axios.create({
    baseURL: process.env.REACT_APP_WORKSPACE_API_ADDR,
    withCredentials: true, // important for cookie-based CSRF/session support
});

// Automatically attach session token to each request
api.interceptors.request.use((config) => {
    config.headers["X-CSRFToken"] = getCSRFToken();
    return config;
});

export default api;

// axios does not support streaming on browser
export function stream(url, body, {
    method = "POST",
    contentType = "application/json"
} = {}) {
    return fetch(`${process.env.REACT_APP_WORKSPACE_API_ADDR}${url}`, {
        method,
        credentials: "include",
        headers: {
            "Content-Type": contentType,
            "X-CSRFToken": getCSRFToken(),
        },
        body,
    });
}
